export default __webpack_public_path__ + "static/media/flag-england.0a45a529.svg";